// Angular
import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
// Service
import { ViewsService } from '../../../../../../../../services/views.service';
import { CVfUtilsService } from '../../../../../../../services/cvf-utils.service';
// Model
import { FormControl, FormGroup } from '@angular/forms';
import { SCHEMA_TYPE } from '../../../../../../../../models/enums.model';
import { SmartTagViewModel } from '../../../model/smartTagView';
import { SmartTagTemplateForm } from '../../../model/smart-tag-template-form.model';

@Component({
	selector: 'cv-schema-render-smart-tag-views-template',
	templateUrl: './smart-tag-views-template.component.html',
})
export class SmartTagViewsTemplateComponent extends SmartTagTemplateForm implements OnInit {

	@Input() smartTagModel: SmartTagViewModel = null;
	@Output() valueChange: EventEmitter<any> = new EventEmitter<any>();

	public orderSchema = '';

	get schemaShouldShowComplexForm(): boolean {
		let response = false;
		const schemasShouldShow = [
			SCHEMA_TYPE.CVDS_40.toString(),
			SCHEMA_TYPE.INSPECTIONLESS_1.toString()
		];

		response = schemasShouldShow.indexOf(this.orderSchema) > -1

		return response
	}

	constructor(
		private viewsService: ViewsService,
		protected cvfUtils: CVfUtilsService
	) {
		super(cvfUtils);
	}

	ngOnInit() {

		this.orderSchema = this.viewsService.order.schema;
		// Basic Form
		this.innerForm = new FormGroup({
			viewQuality: new FormControl(this.smartTagModel.viewQuality),
			description: new FormControl(this.smartTagModel.description)
		});

		switch (this.orderSchema) {
			case SCHEMA_TYPE.CVDS_40:
			case SCHEMA_TYPE.INSPECTIONLESS_1:
				this.innerForm.addControl('viewAffect', new FormControl(this.smartTagModel.viewAffect));
				this.initPreloadedDropdowns([ { field: 'viewAffect', options: this.smartTagViewAffectOptions, value: this.smartTagModel.viewAffect}]);
				break;
		}

		this.initPreloadedDropdowns([ { field: 'viewQuality', options: this.smartTagViewQualityOptions, value: this.smartTagModel.viewQuality}]);

		// Everytime the Form Change
		this.innerForm.valueChanges.subscribe(() => this.onValuesChange());
	}

	/**
	 * Emit values and status of this Form, for inner components and library too
	 * @private
	 */
	public onValuesChange(): void {
		const formValue = this.processOutputObject(this.smartTagModel);
		this.valueChange.next({ valid: this.innerForm.valid, value: formValue });
	}

}
